import { render, staticRenderFns } from "./ImWebimSeat.vue?vue&type=template&id=5207d5aa&scoped=true"
import script from "./ImWebimSeat.vue?vue&type=script&lang=js"
export * from "./ImWebimSeat.vue?vue&type=script&lang=js"
import style0 from "./ImWebimSeat.vue?vue&type=style&index=0&id=5207d5aa&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5207d5aa",
  null
  
)

export default component.exports